module.exports = __webpack_public_path__ + "static/media/opendoublequotes.c10aa3fa.svg";